import styled from 'styled-components';
interface TypeProps {
  type: string;
}

export const Content = styled.div<TypeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 960px) {
    .btns_receivecall span {
      display: none !important;
    }
    .datehour_receivecall {
      width: 320px !important;
      .date_receivecall,
      .hour_receivecall {
        width: 150px !important;
      }
    }
  }

  .title_receivecall {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 16px;
    color: ${(props) => props.theme.colors.black};
    line-height: 19.2px;
    width: 100%;

    .subtitle_receivecall {
      width: 100%;
      margin-top: 24px;

      .default {
        margin-top: 11px;
      }

      span {
        line-height: 16.9px;
        font-weight: 400;
        font-size: 16px;
        color: ${(props) => props.theme.colors.gray};
      }
    }

    .datehour_receivecall {
      max-width: 400px;
      width: 100%;
      display: ${(props) =>
        props.type === 'ReceberLigacao' ? 'none' : 'flex'};
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 24px;

      .date_receivecall {
        input[type='date'] {
          font-family: ${(props) => props.theme.primaryFont} !important;
        }
      }

      .date_receivecall,
      .hour_receivecall {
        width: 190px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          margin-bottom: 11px;
          line-height: 16.9px;
          font-weight: 400;
          font-size: 16px;
          color: ${(props) => props.theme.colors.gray};
        }
      }
    }

    .btns_receivecall {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      margin-top: 24px;

      span,
      p {
        font-size: 16px;
        color: ${(props) => props.theme.colors.white};
      }

      span {
        margin-left: 5px;
      }
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 48px;
  color: ${(props) => props.theme.colors.black};
  background: ${(props) =>
    props.readOnly ? 'transparent' : props.theme.colors.white};
  border: 1.5px solid #dfe4ef;
  border-radius: 4px;
  font-weight: 400;
  padding: 0 20px;
  font-size: 16px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    color: ${(props) => props.theme.colors.gray};
    padding-top: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
`;
